<template>
  <v-card style="display: flex; align-items: center;" class="manageProject">
    <v-btn small icon light @click="$emit('close-manage-dialog')" style="text-align: right; position: absolute; top: 40px; right: 40px; padding: 0; margin: 0">
      <v-icon>close</v-icon>
    </v-btn>
    <v-card-text style="width: 100%; height: 100%; padding: 0 10%">
      <v-flex xs12 style="display: flex; align-items: center; justify-content: center; height: 350px; width: 100%">
        <v-flex v-for="item in getSubscriptionPlans" class="subPlan pa-1 mx-5" :key="item.id" v-if="Number(item.tier) !== 0 || isMaster">
          <div class="subPlanHeader primary--text">
            {{item.displayName}}
          </div>
          <div class="py-3 primary--text" style="font-size: 48px; font-weight: 300">{{ '$' + item.fixedFee}} <span style="font-size: 18px; font-weight: 500" class="primary--text" v-if="Number(item.tier) !== 0">{{getPeriod(item.period)}}</span></div>
          <div style="font-size: 14px; margin-top: 20px" class="primary--text">Includes:</div>
          <ul style="padding-left: 18px">
            <li class="primary--text">{{item.description}}</li>
          </ul>
          <v-btn v-if="selectedPlanId !== item.id" flat outline round color="primary" dark :ripple="false" style="font-size: 18px; text-transform: none; width: 100%; margin: 0; margin-top: 20px; height: 45px;" @click="selectedPlanId = item.id; unsubscribeConfirmed = false; unsubscribeDisplay = false" :disabled="isMaster && Number(item.tier) !== 0">Choose Plan</v-btn>
          <div v-else-if="selectedPlanId === item.id" style="font-size: 18px; text-transform: none; width: 100%; margin: 0; margin-top: 20px; text-align: center; border: 1px solid #2165FF; height: 45px; line-height: 45px; border-radius: 50px; color: #2165FF">Selected</div>
        </v-flex>
      </v-flex>
      <v-divider class="mb-4" style="border-color: #97A4D9"></v-divider>
      <v-flex pb-1 class="text-xs-center primary--text" style="font-size: 24px">
        Or, <span @click="unsubscribeDisplay = true" style="cursor: pointer; text-decoration: underline">unsubscribe from "{{options.project.name}}"</span>
      </v-flex>
      <v-flex :class="unsubscribeDisplay? '' : 'hideVisibility'" pb-4 class="text-xs-center primary--text" style="font-size: 18px">
        Are you sure?
        <span
          @click="unsubscribeConfirmed = true; selectedPlanId = -1"
          style="cursor: pointer; padding: 0 10px; border-radius: 50px; margin-left: 10px"
          :style="unsubscribeConfirmed ? '' : 'border: 1px solid #011E41'"
          :class="unsubscribeConfirmed ? 'primary secondary--text' : 'primary--text'">Yes</span>
        <span
          @click="unsubscribeConfirmed = false; selectedPlanId = originalSelectedPlan"
          style="cursor: pointer; padding: 0 10px; border-radius: 50px; margin-left: 10px;"
          :style="unsubscribeConfirmed ? 'border: 1px solid #011E41' : ''"
          :class="unsubscribeConfirmed ? 'primary--text' : 'primary secondary--text'">No</span>
      </v-flex>
      <v-flex mt-4 style="display: flex; align-items: center; justify-content: flex-end">
        <v-btn class="primary" @click="handleConfirmation()" flat round :ripple="false" style="width: 160px; height: 45px; text-transform: capitalize; font-size: 18px" :disabled="selectedPlanId === originalSelectedPlan && unsubscribeConfirmed === false" :loading="loading">Confirm</v-btn>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<style>
  .manageProject .subPLan{
    border-radius: 10px;
    max-width: 200px;
    cursor: pointer;
  }
  .manageProject .subPlanHeader{
    font-size: 18px;
    font-weight: 800
  }
  .manageProject button:disabled{
    background-color: #B2BBC5 !important;
    color: white !important;
  }
  .manageProject .hideVisibility{
    visibility: hidden;
  }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      selectedPlanId: null,
      originalSelectedPlan: null,
      unsubscribeDisplay: false,
      unsubscribeConfirmed: false,
      loading: false
    }
  },
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({getUserOrganization: 'getUserOrganization', getSubscriptionPlans: 'getSubscriptionPlans', getRoleByName: 'getRoleByName', getPlanById: 'getPlanById'}),
    isMaster () {
      return Number(this.getRoleByName('MASTER_ROLE').id) === Number(this.currentUser.defaultRoleId)
    },
    getStripeSubConfig () {
      if (this.getUserOrganization.organizationProjects.filter(x => { return x.stripeItemId && this.getPlanById(this.originalSelectedPlan).period === this.getPlanById(x.planId).period }).length === 1) {
        return this.getUserOrganization.stripeSubConfig
      } else {
        return null
      }
    },
    getStripeItemId () {
      return this.getUserOrganization.organizationProjects.find(x => { return x.projectId === this.options.project.id }).stripeItemId
    }

  },
  methods: {
    ...mapMutations('notification', ['notify']),
    getPeriod (tierPeriod) {
      if (tierPeriod === 'MONTHLY') {
        return ' /mo'
      } else if (tierPeriod === 'QUARTERLY') {
        return ' /qt'
      } else if (tierPeriod === 'YEARLY') {
        return ' /yr'
      } else {
        return ''
      }
    },
    handleConfirmation () {
      if (this.unsubscribeConfirmed) {
        this.unsubscribe()
      } else {
        this.updatePlan()
      }
    },
    unsubscribe () {
      if (!this.isMaster) {
        this.stripeCompleteUnsubscribe()
      } else {
        this.unsubscribeProject()
      }
    },
    updatePlan () {
      this.loading = true
      if (!this.isMaster) {
        if (this.getStripeItemId !== null && this.getUserOrganization.stripeSubId !== null) {
          let interval = ''
          let intervalCount = 1
          var selectedPlan = this.getPlanById(this.selectedPlanId)
          if (selectedPlan.period === 'MONTHLY') {
            interval = 'month'
          } else if (selectedPlan.period === 'QUARTERLY') {
            interval = 'month'
            intervalCount = 3
          } else if (selectedPlan.period === 'YEARLY') {
            interval = 'year'
          }
          let planOptions = {
            projectUuid: this.options.project.uuid,
            planUuid: selectedPlan.uuid,
            monthlyFee: selectedPlan.fixedFee,
            interval: interval,
            intervalCount: intervalCount,
            trialPeriodDays: 0,
            type: selectedPlan.type,
            period: selectedPlan.period
          }
          axios.all([this.$store.dispatch('stripe/createPlan', { ...planOptions })]).then(axios.spread((planResponse) => {
            if (planResponse.data.status === 'SUCCESS') {
              let subscriptionOptions = {
                id: this.getStripeItemId,
                projectUuid: this.options.project.uuid,
                planUuid: selectedPlan.uuid,
                trialPeriodDays: 0,
                type: selectedPlan.type,
                period: selectedPlan.period
              }
              if (selectedPlan.period === this.getPlanById(this.originalSelectedPlan).period) {
                axios.all([this.$store.dispatch('stripe/updateSubscriptionItem', { ...subscriptionOptions })]).then(axios.spread((stripeResponse) => {
                  if (stripeResponse.data.status === 'SUCCESS' && stripeResponse.data.payload !== undefined) {
                    this.updateProjectPlan(stripeResponse.data.payload.id)
                  }
                })).catch((err) => {
                  this.loading = false
                  this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                  console.log(err)
                })
              } else {
                if (this.getUserOrganization.organizationProjects.filter(x => { return x.stripeItemId && selectedPlan.period === this.getPlanById(x.planId).period }).length === 0) {
                  axios.all([this.$store.dispatch('stripe/createSubscription', {period: selectedPlan.period, organizationUuid: this.getUserOrganization.uuid, projectUuid: this.options.project.uuid, planUuid: selectedPlan.uuid, trialPeriodDays: 0, type: selectedPlan.type})]).then(axios.spread((subscriptionResponse) => {
                    if (subscriptionResponse.data.status === 'SUCCESS') {
                      this.updateProjectPlan(subscriptionResponse.data.payload.items.data[0].id)
                      this.stripeUnsubscribe()
                    } else {
                      this.loading = false
                      this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                    }
                  })).catch((err) => {
                    this.loading = false
                    this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                    console.log(err)
                  })
                } else {
                  axios.all([this.$store.dispatch('stripe/createSubscriptionItem', {period: selectedPlan.period, subscriptionId: this.getUserOrganization.stripeSubConfig[selectedPlan.period], projectUuid: this.options.project.uuid, planUuid: selectedPlan.uuid, trialPeriodDays: 0, type: selectedPlan.type})]).then(axios.spread((subscriptionItemResponse) => {
                    if (subscriptionItemResponse.data.status === 'SUCCESS') {
                      this.updateProjectPlan(subscriptionItemResponse.data.payload.id)
                      this.stripeUnsubscribe()
                    } else {
                      this.loading = false
                      this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                    }
                  })).catch((err) => {
                    this.loading = false
                    this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                    console.log(err)
                  })
                }
              }
            }
          })).catch((err) => {
            this.loading = false
            this.notify({message: 'Something went wrong while connecting to the server.', show: true})
            console.log(err)
          })
        }
      } else {
        this.updateProjectPlan(null)
      }
    },
    stripeUnsubscribe () {
      if (this.getStripeItemId !== null) {
        if (this.getStripeSubConfig === null) {
          axios.all([this.$store.dispatch('stripe/cancelSubscriptionItem', {id: this.getStripeItemId})]).catch((err) => {
            this.loading = false
            this.notify({message: 'Something went wrong while connecting to the server.', show: true})
            console.log(err)
          })
        } else {
          axios.all([this.$store.dispatch('stripe/cancelSubscription', {id: this.getStripeSubConfig[this.getPlanById(this.originalSelectedPlan).period], organizationUuid: this.getUserOrganization.uuid, period: this.getPlanById(this.originalSelectedPlan).period})]).catch((err) => {
            this.loading = false
            this.notify({message: 'Something went wrong while connecting to the server.', show: true})
            console.log(err)
          })
        }
      }
    },
    stripeCompleteUnsubscribe () {
      this.loading = true
      if (this.getStripeItemId !== null && this.options.project.status === 'Active') {
        if (this.getStripeSubConfig === null) {
          axios.all([this.$store.dispatch('stripe/cancelSubscriptionItem', {id: this.getStripeItemId})]).then(axios.spread((stripeResponse) => {
            if (stripeResponse.data.status === 'SUCCESS') {
              this.unsubscribeProject()
            }
          })).catch((err) => {
            this.loading = false
            this.notify({message: 'Something went wrong while connecting to the server.', show: true})
            console.log(err)
          })
        } else {
          axios.all([this.$store.dispatch('stripe/cancelSubscription', {id: this.getStripeSubConfig[this.getPlanById(this.originalSelectedPlan).period], organizationUuid: this.getUserOrganization.uuid, period: this.getPlanById(this.originalSelectedPlan).period})]).then(axios.spread((stripeResponse) => {
            if (stripeResponse.data.status === 'SUCCESS') {
              this.unsubscribeProject()
            }
          })).catch((err) => {
            this.loading = false
            this.notify({message: 'Something went wrong while connecting to the server.', show: true})
            console.log(err)
          })
        }
      }
    },
    updateProjectPlan (stripeItemId) {
      axios.all([this.$store.dispatch('updateOrganizationProject', {organizationId: this.getUserOrganization.id, projectId: this.options.project.id, planId: this.selectedPlanId, type: 'SUBSCRIPTION', stripeItemId: stripeItemId, status: 'Active'})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.getOrganizationData()
        }
      })).catch((err) => {
        this.loading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    unsubscribeProject () {
      var deleteOpObject = {organizationId: this.getUserOrganization.id, projectId: this.options.project.id}
      var deleteOupObject = {organizationId: this.getUserOrganization.id, projectId: this.options.project.id}
      axios.all([this.$store.dispatch('deleteOrganizationProject', deleteOpObject), this.$store.dispatch('deleteOrganizationsUsersProjectsByOrganizationIdAndProjectId', deleteOupObject)]).then(axios.spread((opResponse, oupResponse) => {
        if (opResponse.data.status === 'SUCCESS' && oupResponse.data.status === 'SUCCESS') {
          this.getOrganizationData()
        } else {
          this.loading = false
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.loading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    getOrganizationData () {
      axios.all([this.$store.dispatch('getOrganizationsWithAllById', {id: this.getUserOrganization.id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setUserOrganization', response.data.payload)
          console.log('success')
          this.loading = false
        } else {
          this.loading = false
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.loading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  mounted () {
    if (this.getUserOrganization && this.options.project && this.getUserOrganization.organizationProjects && this.getUserOrganization.organizationProjects.find(item => { return item.projectId === this.options.project.id })) {
      this.selectedPlanId = this.getUserOrganization.organizationProjects.find(item => { return item.projectId === this.options.project.id }).planId
      this.originalSelectedPlan = this.getUserOrganization.organizationProjects.find(item => { return item.projectId === this.options.project.id }).planId
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/appElements/ManageProject.vue